import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2, Cloud, CloudOff, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useGameData } from '@/hooks/use-game-data';

export const DataSyncIndicator: React.FC = () => {
  const { t } = useTranslation();
  const { syncStatus, isLoading, refreshGameData } = useGameData();

  const getStatusIcon = () => {
    switch (syncStatus) {
      case 'loading':
        return <Loader2 className="h-4 w-4 animate-spin" />;
      case 'with_data':
        return <Cloud className="h-4 w-4 text-green-500" />;
      case 'error':
        return <CloudOff className="h-4 w-4 text-red-500" />;
      case 'empty':
        return <Cloud className="h-4 w-4 text-blue-500" />;
      default:
        return <CloudOff className="h-4 w-4 text-gray-400" />;
    }
  };

  const getStatusText = () => {
    switch (syncStatus) {
      case 'loading':
        return t('sync.loading', 'Syncing...');
      case 'with_data':
        return t('sync.synced', 'Synced');
      case 'error':
        return t('sync.error', 'Sync Error');
      case 'empty':
        return t('sync.empty', 'No Data');
      default:
        return t('sync.offline', 'Offline');
    }
  };

  if (syncStatus === 'never') {
    return null;
  }

  return (
    <div className="flex items-center gap-2 text-sm">
      <div className="flex items-center gap-1">
        {getStatusIcon()}
        <span className="text-muted-foreground">{getStatusText()}</span>
      </div>
      
      {syncStatus === 'error' && (
        <Button
          variant="ghost"
          size="sm"
          onClick={refreshGameData}
          disabled={isLoading}
          className="h-6 px-2"
        >
          <RefreshCw className="h-3 w-3" />
        </Button>
      )}
    </div>
  );
};